import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchBlogPosts } from "@/lib/api";
import { ArrowUpRight } from "@phosphor-icons/react";
import PageHero from "@/components/PageHero";

export default function Blog() {
    const [posts, setPosts] = useState([]);

    useEffect(() => {
        document.title = "Surveys2CAD | Blog";
        fetchBlogPosts().then(setPosts).catch(() => {});
    }, []);

    return (
        <div>
            <PageHero variant="blog" tint="rose">
                <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16 md:py-24">
                    <div className="max-w-3xl">
                        <div className="overline mb-3">Resources</div>
                        <h1 className="font-heading text-5xl sm:text-6xl font-bold text-slate-50 tracking-tighter leading-[1.05]">
                            Field-tested <br />
                            <span
                                className="bg-clip-text text-transparent"
                                style={{ backgroundImage: "linear-gradient(120deg, #f43f5e 0%, #a855f7 50%, #22d3ee 100%)" }}
                            >
                                drafting insights.
                            </span>
                        </h1>
                        <p className="text-slate-400 mt-6 text-lg leading-relaxed">
                            Standards breakdowns, workflow deep-dives, and lessons from 330,000+ surveying CAD drawings delivered
                            across the Northern US.
                        </p>
                    </div>
                </div>
            </PageHero>

            <div className="max-w-7xl mx-auto px-5 lg:px-8 py-12 md:py-16">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="blog-grid">
                    {posts.map((p, i) => (
                        <Link
                            key={p.id}
                            to={`/blog/${p.slug}`}
                            className={`tech-card p-7 block group ${i === 0 ? "md:col-span-2 lg:col-span-3" : ""}`}
                            data-testid={`blog-post-${p.slug}`}
                        >
                            <div className="flex items-center gap-3 mb-4 text-xs text-slate-500 font-mono-alt">
                                <span className="text-cyan-400">{p.category}</span>
                                <span className="dot-divider" />
                                <span>{new Date(p.date).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })}</span>
                                <span className="dot-divider" />
                                <span>{p.read_time} read</span>
                            </div>
                            <h3 className={`font-heading font-semibold text-slate-50 tracking-tight mb-3 ${i === 0 ? "text-3xl md:text-4xl" : "text-xl"}`}>
                                {p.title}
                            </h3>
                            <p className="text-slate-400 leading-relaxed">{p.excerpt}</p>
                            <div className="mt-5 inline-flex items-center gap-1.5 text-cyan-300 text-sm font-heading font-medium group-hover:gap-3 transition-all">
                                Read article <ArrowUpRight size={16} weight="bold" />
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </div>
    );
}
